import { Link } from 'react-router-dom';

// Shown after a failed sign-in: many people trying to log in have never had an
// account, and registering for a course doesn't need one.
export default function NoAccountHint({ onNavigate }) {
  return (
    <p className="text-xs text-slate-500 leading-relaxed">
      New here? You don't need an account to register —{' '}
      <Link to="/courses" onClick={onNavigate} className="text-brand font-semibold hover:text-brand-dark">
        pick a course
      </Link>{' '}
      and click <strong>Buy now</strong>. Your account is created at checkout.
    </p>
  );
}
